export default __webpack_public_path__ + "static/media/screenshot6.0198547b.jpg";